document.addEventListener("DOMContentLoaded", function () {
	let btnDisable = true;
	const btn = document.getElementById("confirm");

	const privacyPolicyCheckbox = document.getElementById("00NRB00001YwrZJ");
	privacyPolicyCheckbox.addEventListener("change", function () {
		if (isValidPrivacyPolicy()) {
			btnDisable = false;
			btn.setAttribute("aria-disabled", "false");
		} else {
			btnDisable = true;
			btn.setAttribute("aria-disabled", "true");
		}
	});
	btn.addEventListener("click", function () {
		if (btnDisable) {
			return;
		}
		if (isValidFinalCheck() === false) {
			return;
		}
		if (isEmptyString(document.getElementById("company").value)) {
			alert("会社名をご記入ください");
		} else if (isEmptyString(document.getElementById("00NRB00001IIveT").value)) {
			alert("部署名をご記入ください");
		} else if (isEmptyString(document.getElementById("last_name").value)) {
			alert("お名前(姓)をご記入ください");
		} else if (isEmptyString(document.getElementById("first_name").value)) {
			alert("お名前(名)をご記入ください");
		} else if (isEmptyString(document.getElementById("00NRB00001I6Fcb").value)) {
			alert("お問い合わせ内容をご記入ください");
		} else if (isValidEmail(document.getElementById("email").value) === false) {
			alert("メールアドレス欄をご確認ください");
		} else if (isValidPhoneNumber(document.getElementById("phone").value) === false) {
			alert("電話番号欄をご確認ください");
		} else {
			let checked = window.confirm("お問い合わせを送信します\r\nよろしいですか？");
			if (checked) {
				const confirmInput = document.getElementById("company_confirm");
				if (confirmInput) {
					confirmInput.disabled = true;
				}
				document.web_to_lead.submit();
			}
		}
	});
});
function isEmptyString(text) {
	// 文字列がnull、undefined、または空文字列でないことを確認
	if (text === null || text === undefined || text === "") {
		return true;
	}
	// 文字列の前後にある空白文字を削除し、その結果が空文字列かどうかをチェック
	// .trim() メソッドは文字列の先頭および末尾の空白（スペース、タブ、改行など）を削除します
	return text.trim() === "";
}
/* メールアドレスのチェック(簡易版) */
function isValidEmail(email) {
	// メールアドレスの正規表現（一般的な形式に対応）
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return emailRegex.test(email);
}
/* 電話番号のチェック(ハイフンあり、なし) */
function isValidPhoneNumber(phoneNumber) {
	// ハイフンなし、またはハイフンありの電話番号の正規表現をORで結合
	const phoneRegexWithoutHyphen = /^\d{10,11}$/;
	const phoneRegexWithHyphen = /^0\d{1,3}-\d{1,4}-\d{4}$/;

	return phoneRegexWithoutHyphen.test(phoneNumber) || phoneRegexWithHyphen.test(phoneNumber);
}

function isValidPrivacyPolicy() {
	const privacyPolicyCheckbox = document.getElementById("00NRB00001YwrZJ");
	return privacyPolicyCheckbox.checked;
}

function isValidFinalCheck() {
	const confirmInput = document.getElementById("company_confirm");
	const text = confirmInput.value;
	if (text === "") {
		return true;
	}
	return false;
}